module.exports = require('./register')().Promise



//////////////////
// WEBPACK FOOTER
// ./node_modules/any-promise/index.js
// module id = 94
// module chunks = 0